import React, { useEffect, useMemo } from "react";
import PresenceAnswerV2 from "../PresenceAnswerV2";
import { Constellation } from "./DiscTransitions";
import { discLayout } from "./dotShapes";
import DotStill from "./DotStill";
import { INVITATION } from "./invite";
import { Close, Headline, ShapeStage, useBox, useShapeStory } from "./shared";
import useInvite from "./useInvite";

// The share of the disc's radius left empty in its middle, for the count.
const HOLLOW = 0.52;

// PROTOTYPE (hero shapes): Cerchio, the new hero's first shape, the clients
// on a disc with the count alone in its hollow, going from today to with
// AVRAH as Costellazione tells it (DiscTransitions.jsx), the reveal
// playing as shared.jsx says. Until it plays, the disc and the button
// invite the visitor to press it (invite.js), when useInvite.js says. From
// 900px the headline over the disc, the caption's two sentences either side
// of it and the close under it (shapes.css). Narrower, one centred column:
// the headline, the disc, its caption, the close. Until the disc's box is
// measured, in the built page and as React attaches to it, the clients are
// drawn in its markup (DotStill.jsx), then on its canvas from the same
// frame. `onMark`, if given, is told how far the clients have drawn AVRAH's
// mark, 0 to 1, as it changes.
export default function DiscHero({ rawClients, onClients, onMark }) {
  const story = useShapeStory(rawClients);
  useEffect(() => {
    if (onMark) onMark(story.morph);
  }, [onMark, story.morph]);
  const { watch, at } = useInvite(INVITATION, !story.asked);
  const [artRef, box] = useBox();
  const side = box && box.width;
  const disc = useMemo(() => (side ? discLayout({ clients: story.clients, side, hollow: HOLLOW }) : null), [story.clients, side]);
  const inviting = at !== null;
  const glow = inviting && side ? (dot) => INVITATION.glow(at, dot, side) : undefined;
  return (
    <ShapeStage story={story} shape="disc">
      <Headline rawClients={rawClients} onClients={onClients} />
      <div className="hs-art" ref={artRef} data-digits={String(story.clients).length}>
        {!disc && <DotStill layout={discLayout({ clients: story.clients, side: 100, hollow: HOLLOW })} met={story.met} />}
        <Constellation story={story} disc={disc} glow={glow} />
      </div>
      <PresenceAnswerV2 others={story.others} lit={story.lit} />
      <Close story={story} invited={{ watch, button: inviting ? INVITATION.button(at) : null }} />
    </ShapeStage>
  );
}
